import {
    isLoanBorrower,
    LoopPositionExpanded,
    LoopscalePointsAction,
    useLoopscaleWalletContext,
    usePortfolioRewardsUtils
} from "@bridgesplit/abf-react";
import { LoopPortfolioApy } from "app/components/points";
import { calculateActiveLoanDailyPoints } from "app/components/portfolio/stats";

export function LoopPositionApy({
    loopPosition,
    hideApyText
}: {
    loopPosition: LoopPositionExpanded | undefined;
    hideApyText?: boolean;
}) {
    const {
        data: { userWalletAddress: user }
    } = useLoopscaleWalletContext();

    const { getLoopRewards } = usePortfolioRewardsUtils();
    const loanAddress = loopPosition?.loanExpanded?.loan?.address;
    const isBorrower = isLoanBorrower(loopPosition?.loanExpanded, user);
    const ledgerReward = getLoopRewards(loanAddress);

    const customDailyPoints = calculateActiveLoanDailyPoints(ledgerReward, isBorrower);

    if (!loopPosition?.loanExpanded?.netApyLive) return null;
    return (
        <LoopPortfolioApy
            loopscalePointsAction={LoopscalePointsAction.Borrow}
            apy={loopPosition.loanExpanded.netApyLive}
            customDailyPoints={customDailyPoints}
            loopPosition={loopPosition}
            identifier={loopPosition?.loopExpanded?.collateralToken?.mint}
            hideApyText={hideApyText}
        />
    );
}
